// The app's one Trusted Types policy.
//
// The Content-Security-Policy of ARCHITECTURE 11.8 says require-trusted-types-for 'script' and
// trusted-types scopefold: a plain string that reaches a script sink is refused, and no policy except
// "scopefold" may exist. The only sink the app uses is the script URL of the service worker; the policy
// accepts a same-origin path and nothing else. Any later sink (a worker, a script) gets its own rule here.

export const POLICY_NAME = "scopefold";

let policy: TrustedTypePolicy | undefined;

function scopefoldPolicy(): TrustedTypePolicy | undefined {
  if (policy !== undefined) return policy;
  const factory = window.trustedTypes;
  if (factory === undefined) return undefined;
  policy = factory.createPolicy(POLICY_NAME, {
    createScriptURL(input) {
      const url = new URL(input, window.location.origin);
      if (url.origin !== window.location.origin) throw new TypeError("Only same-origin script URLs are allowed.");
      return url.href;
    },
  });
  return policy;
}

/** A script URL for navigator.serviceWorker.register(). A browser without Trusted Types gets the plain string. */
export function trustedScriptUrl(path: string): TrustedScriptURL | string {
  return scopefoldPolicy()?.createScriptURL(path) ?? path;
}
